/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_PauseInputs */

const en_mascot_pause = /** @type {(inputs: Mascot_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause mascot animation`)
};

const id_mascot_pause = /** @type {(inputs: Mascot_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeda animasi maskot`)
};

/**
* | output |
* | --- |
* | "Pause mascot animation" |
*
* @param {Mascot_PauseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mascot_pause = /** @type {((inputs?: Mascot_PauseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_PauseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mascot_pause(inputs)
	return en_mascot_pause(inputs)
});